import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter, interval, map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ClientUpdateService {
  constructor(
    private swUpdate: SwUpdate,
    private snackbar: MatSnackBar,
    private translateService: TranslateService
  ) {
    if (this.swUpdate.isEnabled) {
      swUpdate.checkForUpdate().then(() => {
      })

      //20 percenkénti ellenőrzés
      let TIMEFRAME = 1000 * 60 * 20;  // 1mp -> 1p -> 20p
      interval(TIMEFRAME).subscribe(() =>
        swUpdate.checkForUpdate().then(() => {
        })
      );
    }

    const updatesAvailable = this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
      map(evt => ({
        type: 'UPDATE_AVAILABLE',
        current: evt.currentVersion,
        available: evt.latestVersion,
      })));

    updatesAvailable.subscribe({
      next: (evt) => {
        this.promptUser();
      }
    })

    this.swUpdate.unrecoverable.subscribe(event => {
      const snack = this.snackbar.open(
        this.translateService.instant('unrecoverable-chunk-detected'),
      );
      // force reload, window.location.reload() doesn't clear cache
      window.location.href = window.location.href;
    });
  }

  promptUser() {
    const snack = this.snackbar.open(
      this.translateService.instant('updateAvailable'),
      this.translateService.instant('reload')
    );

    snack.onAction().subscribe(() => {
      // force reload, window.location.reload() doesn't clear cache
      window.location.href = window.location.href;
    });
  }
}
